import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=5914485c&scoped=true"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"
import style0 from "./Favourite.vue?vue&type=style&index=0&id=5914485c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914485c",
  null
  
)

export default component.exports